// Slot index mapping (mirrors server SlotIdx).
// Lives in its own dependency-free module so both Build.js and buildUtils.js
// can import it without forming a Build <-> buildUtils circular import (which
// TDZ-crashed on `SLOT_IDX` once the module load order changed). Build.js
// re-exports this, so `import { SLOT_IDX } from './Build'` keeps working.
export const SLOT_IDX = {
    HAT: 0,
    CLOAK: 1,
    AMULET: 2,
    RINGS: [3, 4],
    RING1: 3,
    RING2: 4,
    BELT: 5,
    BOOTS: 6,
    WEAPON: 7,
    SHIELD: 8,
    PET: 9,
    PRYSMARADITE: 10,
    TROPHUS: [10, 11, 12, 13, 14, 15], // Dofus/Trophy slots
};
